module.exports = __webpack_public_path__ + "static/media/building4.5688c0c0.png";